import React, { useEffect, useState } from 'react'
import { LineChart, Line, XAxis, Tooltip } from 'recharts';
import Chart from '../../../../../components/Rechart/Chart';
import http from '../../../../../config/BaseUrl';

function TwitterShare({ eventId }) {

  const [isLoading, setIsLoading] = useState(false);
  const [eventGraph, setEventGraph] = useState("");

  const fetchGraphData = async () => {
    try {
      setIsLoading(true)
      await http.get(`event-graph/sharing/${'facebook'}/${eventId}`).then( res =>{
         if(res.data.graphData){
          setIsLoading(false)
          setEventGraph(res.data.graphData)
         }
          
       
      }).catch((err) => {
        console.log('fail');
        setIsLoading(false)
      })
    } catch (error) {
      
    }
  }

  const graphTotalText = {
    week: `This Week`,
    month: 'This Month',
    year: 'This Year'
  }

  useEffect(()=>{
    fetchGraphData()
  }, [])

  return (
    <Chart 
      loading={isLoading}
      graphTotalText={graphTotalText}
      sectionTitle={"Twitter"} 
      sectionName={"twitter"} 
      dataSet={eventGraph} 
      width={330} 
      height={180} 
      dataKey={"share"} 
    />
  )
}

export default TwitterShare
